import {queryToString} from '@wix/wixstores-client-storefront-sdk/dist/src/services/utils';
import {Experiments} from '../constants';
import {ReadOnlyExperiments} from '@wix/wix-experiments';

export enum WarmUpDataRequestType {
  PRODUCTS = 'products',
  INITIAL_DATA = 'initialData',
  OLD_INITIAL_DATA = 'oldInitialData',
  CATEGORY_INITIAL_DATA = 'categoryInitialData',
  FILTERS = 'filters',
}

export function isWarmUpDataEnabled(experiments: ReadOnlyExperiments): boolean {
  return experiments.enabled(Experiments.EnableWarmUpDataCaching);
}

export function generateComponentCollectionCacheKey(mainCollectionId: string | null, compId: string) {
  const collection = mainCollectionId || 'default';
  return `${collection}_${compId}`;
}

export function createWarmUpDataKey(
  requestType: WarmUpDataRequestType,
  cacheKeyOrComponentCollectionKey: string,
  query?: Record<string, any>
): string {
  const urlParams = queryToString(query) || 'default';
  return `${requestType}_${cacheKeyOrComponentCollectionKey}_${urlParams}`;
}
